import { render, staticRenderFns } from "./PaymentAction.vue?vue&type=template&id=2698cae4&scoped=true"
import script from "./PaymentAction.vue?vue&type=script&lang=ts"
export * from "./PaymentAction.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PaymentAction.vue?vue&type=style&index=0&id=2698cae4&prod&lang=stylus&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2698cae4",
  null
  ,true
)

export default component.exports